// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__sVf0C","header":"styles_header__8QItr","text":"styles_text__QgQGC","functionLayout":"styles_functionLayout__2aC7S"};